import { log } from '../utils/loggingUtil';
import { PREBID_IFRAME_ORIGIN } from '../rui-env-variables';

var prebidResultListener = function prebidResultListener(message, handler) {
  return function (event) {
    if (event.origin !== PREBID_IFRAME_ORIGIN) return;
    var data;

    try {
      data = JSON.parse(event.data);
    } catch (e) {
      return;
    }

    if (data.message && data.message === message) {
      event.stopImmediatePropagation();
      handler(data);
    }
  };
};

var eventListeners = [];

var removePrebidEventListeners = function removePrebidEventListeners() {
  eventListeners.forEach(function (eventListener) {
    return window.removeEventListener('message', eventListener);
  });
  eventListeners = [];
};

var postMsgToRemoveAdUnits = function postMsgToRemoveAdUnits() {
  var _window$frames$prebid;

  if (typeof ((_window$frames$prebid = window.frames.prebid) === null || _window$frames$prebid === void 0 ? void 0 : _window$frames$prebid.postMessage) !== 'function') {
    return;
  }

  var message = JSON.stringify({
    message: 'remove_ad_units'
  });
  window.frames.prebid.postMessage(message, PREBID_IFRAME_ORIGIN);
};

var clearPrebidState = function clearPrebidState() {
  removePrebidEventListeners();
  postMsgToRemoveAdUnits();
};

var waitForPrebidIfRequired = function waitForPrebidIfRequired(adSpot) {
  if (!adSpot.isPrebid) {
    return Promise.resolve({
      bidResult: undefined,
      isDemoApp: false
    });
  }

  var prebidMessage = "bidding_completed_".concat(adSpot.params.pos);
  return new Promise(function (resolve) {
    var prebidResultReceiver = prebidResultListener(prebidMessage, function (_ref) {
      var bidResult = _ref.bidResult,
          isDemoApp = _ref.isDemoApp;
      log("Prebid result received for ".concat(adSpot.params.pos, " event listener. bidResult: "), bidResult);
      window.removeEventListener('message', prebidResultReceiver);
      eventListeners = eventListeners.filter(function (eventListener) {
        return eventListener !== prebidResultReceiver;
      });
      resolve({
        bidResult: bidResult,
        isDemoApp: isDemoApp
      });
    });
    window.addEventListener('message', prebidResultReceiver, false);
    eventListeners.push(prebidResultReceiver);
  });
};

export { waitForPrebidIfRequired, clearPrebidState };
//# sourceMappingURL=prebid.js.map